import React from 'react';
import { EmailTestComponent } from '@/components/debug/EmailTestComponent';

const EmailDebugPage: React.FC = () => {
  return (
    <div className="bg-[#0f141c] min-h-screen pt-16 p-8">
      <div className="max-w-6xl mx-auto">
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-white">Debug de Email</h1>
          <p className="text-gray-400 mt-2">
            Ferramentas para testar e debugar o sistema de emails da plataforma
          </p>
        </div>
        
        <EmailTestComponent />
      </div>
    </div>
  );
};

export default EmailDebugPage; 